import { SwiperOptions } from 'swiper/types';

export const homePageSliderConfig: SwiperOptions = {
  direction: 'horizontal',
  speed: 1000,
  slidesPerView: 1,
  keyboard: true,
  mousewheel: false,
  spaceBetween: 0,
  observer: true,
  autoplay: {
    delay: 4000,
  },
  effect: 'fade',
  navigation: {
    nextEl: `.swiper-home-banner .swiper-button-next`,
    prevEl: `.swiper-home-banner .swiper-button-prev`,
  },
  pagination: {
    dynamicBullets: true,
  },
};
